import React from 'react'
import { Button, makeStyles, Text, tokens } from '@fluentui/react-components'
import { Modal } from '../../components/common/modal/Modal'
import { GridItem } from '../../components/common/grid/GridItem'
import { Grid } from '../../components/common/grid/Grid'
import { t } from '../../i18n/i18n'

const useStyles = makeStyles({
   buttonContainer: {
      display: 'flex',
      marginLeft: 'auto',
      gap: tokens.spacingVerticalMNudge,
   }
})

interface ModalWarningConfirmProps {
   open: boolean
   confirmFunction: (confirmed: boolean) => void
   title: string
   message: string
   confirmButtonText: string
}

export const ModalWarningConfirm = ({ open, title, message, confirmButtonText, confirmFunction}: ModalWarningConfirmProps) => {
   const classes = useStyles()

   return (
      <Modal title={title} open={open}>
         <Grid>
            <GridItem size="12/12">
               <Text size={400}>{message}</Text>
            </GridItem>
            <GridItem size="12/12" className={classes.buttonContainer}>
               <Button size="large" appearance="outline" onClick={() => confirmFunction(false)}>
                  {t('Cancel')}
               </Button>
               <Button size="large" appearance="primary" onClick={() => confirmFunction(true)}>
                  {confirmButtonText}
               </Button>
            </GridItem>
         </Grid>
      </Modal>
   )
}
